import { useEffect, useState } from "react";
import api from "../../../../services/api";
import HeaderSession from "../../../../utils/headerSession";
import Loading from "../../../../load/loading";
import SearshEstabelecimento from "../../../../utils/searchEstabelecimento";
import FerramentaNavegacaoExportacao from "../../../../utils/paginacao";
import ListaSolicitacao from "./listaSolicitacao";
import RegisterAccess from "../../../../utils/registerAccess";
import { SolicitacoesLicenciamentoReprovadosExcel } from "../../../exports/gerarelatorioexcel";
import { SolicitacaoLicenciamentoReprovadosPdf } from "../../../exports/gerarelatoriopdf";
import { useSearchParams } from "react-router-dom";
import TabelaLoading from "../../../../load/tabelaLoading";

export default function SolicitacoesReprovadas() {
  // const user = useSelector(state => state.account.user);
  const [tipo, setTipo] = useState("");
  const [status, setStatus] = useState("");
  const [provincia, setProvincia] = useState("");
  const [estabelecimentos, setEstabelecimentos] = useState("");
  const [perPage, setPerPage] = useState(50);
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState("");
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");


  useEffect(() => {
    setLoading(true);
    setEstabelecimentos("");
    api.get(`/estabelecimentos?page=${page}&status=Reprovado&perPage=${perPage}&tipoId=${tipo}&status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&sortBy=dataDespacho:ASC`) //&sortBy=nome:${order}
      .then((response) => {
        // setEstabelecimentos(response.data.estabelecimentos);
        setConfigLista(response.data);
        setEstabelecimentos((prevItems) => [
          ...prevItems,
          ...response.data.estabelecimentos,
        ]);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [page, perPage, order, tipo, status, provincia, dataInicio, dataFim]);
  return (
    <>
      <RegisterAccess page={"solicitações reprovadas"} />

      <HeaderSession
        title="LISTA DE PROCESSOS REPROVADOS"
        actions={true}
        handleExportExcel={() =>
          SolicitacoesLicenciamentoReprovadosExcel(estabelecimentos)
        }
        handleExportPDF={() => SolicitacaoLicenciamentoReprovadosPdf(estabelecimentos)}
      />

      <SearshEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        setProvincia={setProvincia}
        setDataInicio={setDataInicio}
        setDataFim={setDataFim}
        dataInicio={dataInicio}
        dataFim={dataFim}
        statuss={status}
        provincia={provincia}
        tipo={tipo}
        placeholder={"Filtra por nome, número de entrada, data"}
      />

      {estabelecimentos && (
        <ListaSolicitacao
          estabelecimentos={estabelecimentos}
          setEstabelecimentos={setEstabelecimentos}
          tipo={tipo}
          setTipo={setTipo}
          provincia={provincia}
          setProvincia={setProvincia}
          setDataInicio={setDataInicio}
          setDataFim={setDataFim}
          dataInicio={dataInicio}
          dataFim={dataFim}
        >

          <FerramentaNavegacaoExportacao
            configLista={configLista}
            lista={estabelecimentos}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}
          />
        </ListaSolicitacao>

      )}

      {loading && <TabelaLoading />}
    </>
  );
}
